(function () {
  function initFlavorSelect() {
    const select = document.querySelector('[data-shinzo-flavor-select]');
    if (!select) return;
    select.addEventListener('change', () => {
      if (select.value && select.value !== '#') {
        window.location.href = select.value;
      }
    });
  }

  const configEl = document.getElementById('shinzo-product-config');
  let CONFIG = {};
  if (configEl) {
    try {
      CONFIG = JSON.parse(configEl.textContent);
    } catch (e) {
      CONFIG = {};
    }
  }

  const RECHARGE_SELECTORS =
    '.rc-container, .rc-widget, .rc_container_wrapper, .recharge-subscription-widget, recharge-subscription-widget';

  function formatMoney(cents) {
    cents = Number(cents) || 0;
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, CONFIG.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getForm() {
    return document.getElementById('shinzo-product-form');
  }

  function guardVariantIdInput(form) {
    const variantInput = form?.querySelector('[data-shinzo-variant-select]');
    if (!variantInput) return;
    if (variantInput.getAttribute('name') !== 'id') {
      variantInput.setAttribute('name', 'id');
    }
  }

  function rechargeWidgetPresent(root) {
    return Boolean(root?.querySelector(RECHARGE_SELECTORS));
  }

  function initRechargeWidget() {
    const root = document.querySelector('[data-shinzo-recharge-root]');
    const mount = document.querySelector('[data-shinzo-recharge-mount]');
    const form = getForm();
    if (!root || !mount || !form) return;

    const productId = Number(CONFIG.productId || root.dataset.productId);
    if (!productId) return;

    function clearMount() {
      mount.querySelectorAll(RECHARGE_SELECTORS).forEach((el) => el.remove());
      mount.innerHTML = '';
    }

    function tryCreateWidget() {
      if (typeof window.ReChargeWidget === 'undefined' || !window.ReChargeWidget.createWidget) {
        return false;
      }

      clearMount();
      guardVariantIdInput(form);

      try {
        window.ReChargeWidget.createWidget({
          productId,
          injectionParent: '.shinzo-pdp__recharge-mount',
        });
      } catch (e) {
        return false;
      }

      guardVariantIdInput(form);
      return rechargeWidgetPresent(root);
    }

    function ensureWidget() {
      const appBlocks = root.querySelector('[data-shinzo-recharge-app-blocks]');
      if (appBlocks && rechargeWidgetPresent(appBlocks)) {
        return true;
      }

      if (rechargeWidgetPresent(mount)) {
        return true;
      }

      return tryCreateWidget();
    }

    let attempts = 0;
    const poll = setInterval(() => {
      if (ensureWidget() || ++attempts > 100) {
        clearInterval(poll);
      }
    }, 200);

    const variantInput = form.querySelector('[data-shinzo-variant-select]');
    if (variantInput) {
      variantInput.addEventListener('change', () => {
        guardVariantIdInput(form);
        setTimeout(tryCreateWidget, 150);
      });
    }

    const obs = new MutationObserver(() => guardVariantIdInput(form));
    obs.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['name'] });
  }

  function initGallery() {
    const main = document.getElementById('shinzo-pdp-main-image');
    const thumbs = document.querySelectorAll('[data-shinzo-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        const fullSrc = btn.dataset.fullSrc;
        if (!fullSrc) return;

        main.src = fullSrc;
        if (btn.dataset.srcset) {
          main.srcset = btn.dataset.srcset;
        } else {
          main.removeAttribute('srcset');
        }
        if (btn.dataset.alt) {
          main.alt = btn.dataset.alt;
        }

        thumbs.forEach((t) => {
          t.classList.toggle('is-active', t === btn);
          t.setAttribute('aria-selected', t === btn ? 'true' : 'false');
        });
      });
    });
  }

  function initPackToggle() {
    if (!CONFIG.hasPackToggle) return;
    const form = getForm();
    const variantInput = form?.querySelector('[data-shinzo-variant-select]');
    const buttons = document.querySelectorAll('[data-shinzo-pack-toggle] [data-pack]');
    if (!form || !variantInput || !buttons.length) return;

    function setPack(pack) {
      const id = CONFIG.variantIds[pack];
      if (!id) return;
      variantInput.value = String(id);
      guardVariantIdInput(form);
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      variantInput.dispatchEvent(new Event('input', { bubbles: true }));
      buttons.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.pack === pack);
      });
      document.dispatchEvent(
        new CustomEvent('shinzo:pack-change', {
          bubbles: true,
          detail: { pack },
        })
      );
      updatePrices(pack);
    }

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => setPack(btn.dataset.pack));
    });

    setPack('10');
  }

  function updatePrices(pack) {
    const key = pack === '25' ? '25' : '10';
    const data = CONFIG.prices[key];
    if (!data) return;

    document.querySelectorAll('[data-shinzo-atc-price]').forEach((el) => {
      el.textContent = formatMoney(data.price);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initFlavorSelect();
    if (!configEl) return;
    initGallery();
    initPackToggle();
    initRechargeWidget();
  });
})();
